import { getAllTags } from './data';

const matterTags = new Map();
export class Mattertag {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  static subscribe = ({ mpSdk, mpTags, treedisTags }, subscriber) => {
    if (!mpTags) return;
    // eslint-disable-next-line array-callback-return
    Object.keys(mpTags).map((idx) => {
      matterTags.set(idx, mpTags[idx]);
    });
    const matterportTags = Object.values(mpTags);
    const allTags = getAllTags(matterportTags, treedisTags);
    subscriber(allTags);

    // let addedMatterportTags = false;

    // mpSdk.Mattertag.data.subscribe({
    //   onAdded: (idx, item) => {
    //     if (addedMatterportTags) {
    //       // Added Transient Tag
    //     } else {
    //       // Added Matterport Tag
    //       matterTags.set(idx, item);
    //     }
    //   },
    //   onCollectionUpdated: (collection) => {
    //     if (addedMatterportTags) return;
    //     // Matterport tags finished initially adding
    //     addedMatterportTags = true;
    //     const matterportTags = Object.values(collection);
    //     const allTags = getAllTags(matterportTags, treedisTags);
    //     subscriber(allTags);
    //   },
    // });
  };

  static getMatterTags = () => {
    return matterTags;
  };
}
